import { createSDSCollectionItem } from './createSDSCollectionItem';
import { format } from 'owa-strings/utilities/format';
import { getSDSCollectionItemId } from './getSDSCollectionItemId';
import { ITEM_ID_URL } from '../utils/constants';
import { makeSDSNetworkCall } from './makeSDSNetworkCall';

/**
 * Service to update an item in a collection in SDS
 * @param collectionName Collection in which the item is to be updated
 * @param body Key value pairs to be updated
 * unexpected errors which are reported: Please do not store EMPTY ARRAYS in SDS, it will throw an error saying CollectionTypeNameRequired
 */
export async function updateSDSCollectionItem(
    collectionName: string,
    itemClass: string,
    /* eslint-disable-next-line @typescript-eslint/no-explicit-any --
     * See aka.ms/mini-lint-errors
     *	> Unexpected any. Specify a different type. */
    body: any
) {
    const itemIdResponse = await getSDSCollectionItemId(collectionName);
    if (itemIdResponse === '') {
        return createSDSCollectionItem(collectionName, itemClass, body);
    }
    if (itemIdResponse && typeof itemIdResponse === 'string') {
        return makeSDSNetworkCall(format(ITEM_ID_URL, collectionName, itemIdResponse), 'PATCH', {
            ...body,
        });
    } else {
        return itemIdResponse;
    }
}
